export interface UntappdIds {
  locationId: string
  themeId: string
}

const untappdIframeUrl =
  /^https:\/\/business\.untappd\.com\/embeds\/iframes\/(\d+)\/(\d+)\/?$/i
const untappdIframe =
  /<iframe\b[^>]*\bsrc\s*=\s*["']https:\/\/business\.untappd\.com\/embeds\/iframes\/(\d+)\/(\d+)\/?["'][^>]*>/i

/**
 * Extracts numeric IDs from supported Untappd inputs without retaining markup.
 *
 * @param value Untappd iframe URL, official iframe snippet, or location/theme pair.
 */
export function extractUntappdIds(value: string): UntappdIds | null {
  const trustedUrl =
    value.trim().match(untappdIframeUrl) ?? value.match(untappdIframe)
  if (trustedUrl?.[1] && trustedUrl[2]) {
    return { locationId: trustedUrl[1], themeId: trustedUrl[2] }
  }

  const idPair = value.match(/^\s*(\d+)\s*[/:]\s*(\d+)\s*$/)
  if (idPair?.[1] && idPair[2]) {
    return { locationId: idPair[1], themeId: idPair[2] }
  }

  return null
}
